import style from "./Welcome.module.css";
import { motion } from "framer-motion";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useSelector } from "react-redux";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaGoogle } from 'react-icons/fa'; 

const login_url = process.env.REACT_APP_API_URL + '/oauth/login';
//modify here
const google_login_url = process.env.REACT_APP_API_URL + '/oauth/google/login';

const Welcome = () => {
  const windowWidth = useSelector(selectWindowWidth);

  const handleGuestBrowse = async (e) => {
    e.preventDefault();
    localStorage.removeItem('googleToken');
    localStorage.setItem('guestMode', 'true');
    
    await Promise.all([
      fetch(process.env.REACT_APP_API_URL + '/oauth/logout', {
        method: 'GET',
        credentials: 'include'
      }).catch(() => {}),
      fetch(process.env.REACT_APP_API_URL + '/oauth/google/logout', {
        method: 'GET',
        credentials: 'include'
      }).catch(() => {})
    ]);
    
    window.location.href = '/home';
  }

  return (
    <div className={style["homepage"]}>
      {windowWidth > 1000 &&
        <motion.div
          className={style["title"]}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 style={{ fontSize: "70px", fontWeight: 'bold' }}>NCTU+</h1>
          <p style={{ fontSize: "30px" }}>Stay with you in NCTU.</p>
        </motion.div>
      }
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{
          right: windowWidth > 1000 && '10%',
          position: windowWidth > 1000 && 'absolute',
          margin: windowWidth <= 1000 && 'auto',
          width: windowWidth > 1000 ? 'max(30%, 300px)' : windowWidth > 700 ? '50%' : '80%'
        }}
      >
        <Card bg='light' text='dark' style={{ height: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Card.Title style={{ fontSize: '30px' }}>JUMP INTO</Card.Title>
          <Card.Title style={{ fontSize: '50px', fontWeight: 'bold' }}>NCTU+</Card.Title>
          <Button
            size="lg"
            variant="outline-dark"
            onClick={() => {
              localStorage.removeItem('guestMode');
              window.location.href = google_login_url;
            }}
            style={{
              width: windowWidth > 1000 ? '60%' : '50%',
              marginTop: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FaGoogle style={{ marginRight: '10px' }} /> Google 登入
          </Button>
          <Button
            size="lg"
            variant="dark"
            onClick={() => {
              localStorage.removeItem('guestMode');
              localStorage.removeItem('googleToken');
              window.location.href = login_url;
            }}
            style={{
              width: windowWidth > 1000 ? '60%' : '50%',
              marginBottom: '30px',
              marginTop: '30px'
            }}
          >
            e3 登入
          </Button>
          <Button
            size="lg"
            variant="dark"
            onClick={handleGuestBrowse}
            style={{ width: windowWidth > 1000 ? '60%' : '50%' }}
          >
            訪客瀏覽
          </Button>
        </Card>
      </motion.div>
    </div>
  );
}

export default Welcome;